module.exports = "/images/agent-onboarding-3.png?aca653006ae47ee8a87fdffac8290e46";